import styled from 'styled-components';

import { Flex, Text } from '@olxbr/ds-web';

export const Container = styled(Flex)`
  padding: 0 var(--spacing-stack-xxs);
`;

export const Wrapper = styled(Flex)`
  text-align: initial;
  width: 100%;

  @media (min-width: 1030px) {
    width: 50%;
  }
`;

export const Title = styled(Text.TitleMedium)`
  margin-top: var(--spacing-stack-nano);
  margin-bottom: var(--spacing-stack-nano);

  @media (min-width: 1030px) {
    margin-bottom: var(--spacing-stack-xl);
  }
`;

export const Subtitle = styled(Text.BodySmall)`
  strong {
    font-weight: bold;
  }
`;

export const DescriptionItemContainer = styled(Flex)`
  padding: var(--spacing-stack-sm) 0;
`;

export const ImageContainer = styled.div`
  height: 230px;
  margin-bottom: var(--spacing-stack-xxs);

  @media(min-width:1000px) {
    margin-bottom: 0;
  }
`;

export const DescriptionTitle = styled(Text.TitleSmall)`
  padding-bottom: var(--spacing-stack-xxxs);
`;

export const ContentContainer = styled(Flex)`
  padding-bottom: var(--spacing-stack-xxxs);
`;

export const TagContainer = styled.div`
  width: max-content;
  padding-bottom: var(--spacing-stack-nano);
`;

export const ContentTitle = styled(Text.BodyMedium)`
  font-weight: var(--font-weight-bold);
`;
